import React from 'react'
import styled from 'styled-components'
import { Table, useMediaSize, get } from '@ally/metronome-ui'
import { AccountType } from '@ally/data-types-afg-accounts'
import { getColumns } from './TableColumns'
import { useCustomizeDashboard } from '../../Customizations/customizationContext/CustomizeDashboardContext'
import MobileHomeLoansList from '../MobileAccountsCard/MobileHomeLoansList'
import { useAccountTypes } from '../../providers'
import {
  AccountCard,
  AccountCardMbox,
  AccountGroup,
  NonPrintingWrapper,
} from '../Shared'
import { useHostServices } from '../../HostServices'
import { sortByStatusAndAccountNumber } from './utils'

// Added margin-top 5px to create even space above and below the divider
const StyledDivider = styled.div`
  border-top: 1px solid ${get.colors('slate-2')};
  margin-top: 5px;
`

const Mortgage: React.FC = () => {
  const { featureFlags } = useHostServices()
  const [{ dashboardView }] = useCustomizeDashboard()
  const { allMortgageAccounts } = useAccountTypes()

  const mortgageAccounts = allMortgageAccounts.filter(
    account => account.type === AccountType.MORTGAGE,
  )
  const helocAccounts = allMortgageAccounts.filter(
    account => account.type === AccountType.HOME_EQUITY,
  )

  const isMdDown = useMediaSize('MdDown')
  const isLgDown = useMediaSize('LgDown')
  const isPrint = window.matchMedia('print').matches

  const sortedMortgageAccounts = sortByStatusAndAccountNumber(mortgageAccounts)
  const sortedHelocAccounts = sortByStatusAndAccountNumber(helocAccounts)
  const allSortedHomeLoanAccounts = [
    ...sortedMortgageAccounts,
    ...sortedHelocAccounts,
  ]

  return (
    <>
      <AccountGroup name="home-loan">
        <AccountCard type="MORTGAGE">
          {isMdDown && !isPrint ? (
            <MobileHomeLoansList accounts={allSortedHomeLoanAccounts} />
          ) : (
            <>
              {sortedMortgageAccounts.length ? (
                <Table
                  config={{
                    data: sortedMortgageAccounts,
                    columns: getColumns({
                      tableTypeHeader: 'Mortgage',
                      view: dashboardView,
                      isLgDown,
                      allHomeLoanAccounts: allSortedHomeLoanAccounts,
                      featureFlags,
                    }),
                  }}
                  shared={{
                    captionText:
                      'Information about your Ally mortgage accounts',
                    disableContainer: true,
                  }}
                  table={{
                    fullWidth: true,
                    footer: {
                      enabled: !helocAccounts.length,
                    },
                  }}
                />
              ) : // istanbul ignore next
              null}

              {sortedHelocAccounts.length ? (
                <>
                  {sortedHelocAccounts.length && mortgageAccounts.length ? (
                    <StyledDivider />
                  ) : // istanbul ignore next
                  null}
                  <Table
                    config={{
                      data: sortedHelocAccounts,
                      columns: getColumns({
                        tableTypeHeader: 'Home Equity',
                        view: dashboardView,
                        isLgDown,
                        allHomeLoanAccounts: allSortedHomeLoanAccounts,
                        featureFlags,
                      }),
                    }}
                    shared={{
                      captionText:
                        'Information about your Ally home equity lines of credit',
                    }}
                    table={{
                      fullWidth: true,
                      footer: {
                        enabled: true,
                      },
                    }}
                  />
                </>
              ) : // istanbul ignore next
              null}
            </>
          )}
          <NonPrintingWrapper>
            <AccountCardMbox name="ally-dashboard-mortgage-well" />
          </NonPrintingWrapper>
        </AccountCard>
      </AccountGroup>
    </>
  )
}

export default Mortgage
